import { Box, Chip, FormControlLabel, Link } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Container = styled(Box)(({ theme }) => ({
  '& .content': {
    marginTop: 16,
    backgroundColor: theme.palette.grey[50],
    '& .text': {
      fontWeight: 400,
      fontSize: '14px',
    },
    '& a': {
      color: theme.palette.primary.main,
    },
  },

  '& .opt': {
    display: 'flex',
  },

  '& .actions': {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: '8px',
    margin: '8px 0',

    a: {
      color: theme.palette.primary.main,
      border: `1px solid ${theme.palette.primary.main}`,
      height: '36px',
      borderRadius: theme.shape.customBorderRadius.main,
      fontWeight: 500,
      fontSize: '14px',
      letterSpacing: '0.4px',
      lineHeight: '24px',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  '& .person-info': {
    display: 'flex',
    flexDirection: 'column',

    '& .top-container': {
      display: 'flex',
      justifyContent: 'space-between',

      a: {
        color: theme.palette.primary.main,
        textDecoration: 'none',
        fontWeight: 500,
        fontSize: '14px',
        letterSpacing: '0.15px',
        lineHeight: '18px',
      },

      '& .MuiChip-root': {
        marginRight: '0px',
      },

      '& .title': {
        fontSize: '14px',
        color: theme.palette.primary.main,
        lineHeight: '18px',
        letterSpacing: '0.15px',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        maxHeight: '38px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        '& .MuiSvgIcon-root': {
          marginRight: '8px',
        },
      },

      '& .payment': {
        display: 'flex',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
          marginRight: '8px',
        },
      },

      '& .address': {
        marginTop: '4px',
        fontSize: '14px',
        color: theme.palette.text.primary,
        lineHeight: '24px',
        letterSpacing: '0.15px',
        fontWeight: 'normal',
      },
    },

    '& .property-info': {
      display: 'flex',
      flexDirection: 'column',

      '& .MuiBox-root': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '8px',
        borderRadius: '2px',
        border: `1px solid ${theme.palette.grey[200]}`, //theme.GREY_VARIANT

        ':nth-of-type(even)': {
          border: 'none',
          borderRadius: '2px',
          backgroundColor: theme.palette.background.default,
        },

        '&.pending-payment': {
          border: 'none',
          borderRadius: '2px',
          backgroundColor: theme.legacyColors.YELLOW_30,
        },

        '& .MuiTypography-root': {
          fontSize: '0.8rem',
          lineHeight: '24px',
          letterSpacing: '0.15px',
          fontWeight: '400',
        },
      },
    },

    '& .payment-info': {
      marginTop: '20px',
      border: `1px solid ${theme.palette.text.secondary}`,
      padding: '8px',
      borderRadius: theme.shape.customBorderRadius.main,
      backgroundColor: theme.palette.common.white,

      '& .container': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        ':not(:last-child)': {
          paddingBottom: '8px',
        },

        '& .title': {
          fontSize: '14px',
          color: theme.palette.text.primary,
          lineHeight: '18px',
          display: 'flex',
          alignItems: 'center',

          '& .key': {
            fontWeight: '500',
            marginRight: '4px',
          },

          '& .MuiSvgIcon-root': {
            fontSize: '14px',
            lineHeight: '18px',

            width: '14px',
            height: '14px',
            marginRight: '4px',
          },
        },
        '& .link': {
          marginRight: '4px',
        },
      },
    },
  },

  '& .tags': {
    backgroundColor: theme.palette.grey[50],
    padding: '8px',
    borderRadius: theme.shape.customBorderRadius.main,
    margin: '16px 0 8px',
  },
}))

export const StyledLink = styled(Link)({
  textDecoration: 'none',
})

export const StyledChip = styled(Chip)({
  marginLeft: '8px',
})

export const IconsGroup = styled('div')({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center',
  marginBottom: 8,
})

export const LanguageSelectContainer = styled('section')({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  rowGap: 16,
  width: '600px',
  marginTop: 40,
  '& .MuiFormGroup-root': {
    display: 'flex',
    rowGap: '1rem',
  },
})

export const LanguageOption = styled(FormControlLabel)({
  display: 'flex',
  justifyContent: 'space-between',
  height: '40px',
})
